export default __webpack_public_path__ + "assets/images/9aae7f53dfd2e30111f5006fc6f96891.jpg";